import { SECTORS } from "@/data/content";

export const Marquee = () => {
    const items = [...SECTORS, ...SECTORS];
    return (
        <div className="overflow-hidden border-y border-white/10 bg-omsivo-deep py-5" data-testid="sector-marquee" aria-hidden>
            <div className="marquee-track">
                {items.map((s, i) => (
                    <span key={i} className="flex items-center whitespace-nowrap font-display text-lg font-semibold uppercase tracking-[0.22em] text-white/45">
                        <span className="px-6">{s}</span>
                        <span className="h-1.5 w-1.5 rounded-full bg-flame" />
                    </span>
                ))}
            </div>
        </div>
    );
};
